import React, {useState} from 'react';
import {Box} from '@mui/material';
import ArrAccordionWithCheckbox from '../../../components/common/arr-accordion-with-checkbox/ArrAccordionWithCheckbox';

const ArrAccordionWithCheckboxDemo: React.FC = () => {
  const [sections, setSections] = useState([
    {
      id: 'section1',
      title: {primaryText: 'DAT', secondaryText: '(Required)'},
      content:
        'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, doloribus architecto. Doloribus repellendus obcaecati debitis, veniam magnam suscipit. Ipsam vitae itaque, cumque aliquam unde excepturi assumenda rerum facere quas corrupti.',
      checked: true,
    },
    {
      id: 'section2',
      title: {
        primaryText: 'Native',
      },
      content:
        'Lorem ipsum dolor sit amet consectetur adipisicing elit. Nulla, officiis. Est incidunt repellat odit dolore nobis sunt excepturi quos inventore, exercitationem, fugit necessitatibus eveniet quasi quaerat id maiores cum numquam!',
      checked: false,
    },
    {
      id: 'section3',
      title: {primaryText: 'TIFF / PDF'},
      content:
        'Lorem ipsum dolor sit amet consectetur adipisicing elit. Facilis fugit tempora illo sit eum ipsa necessitatibus impedit expedita labore perspiciatis sed magni vitae excepturi explicabo eos quibusdam consectetur, nulla magnam?',
      checked: false,
      //   isDisabled: true,
    },
    {
      id: 'section4',
      title: {primaryText: 'Text'},
      content:
        'Lorem ipsum dolor sit amet consectetur adipisicing elit. Inventore earum fuga placeat voluptatem amet cumque ipsam, autem, minus harum iure dolorem consequatur sit atque adipisci ipsa culpa possimus blanditiis error.',
      checked: true,
    },
  ]);

  const handleToggle = (sectionId: string) => {
    console.log('Toggled section:', sectionId);
  };

  const handleCheckChange = (sectionId: string, checked: boolean) => {
    setSections((prev) =>
      prev.map((sec) => (sec.id === sectionId ? {...sec, checked} : sec))
    );
  };

  return (
    <Box
      style={{
        backgroundColor: 'black',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center', // fixed
        flex: 1,
        padding: '16px',
      }}
    >
      <ArrAccordionWithCheckbox
        sections={sections}
        expandedSection="section1"
        onToggle={handleToggle}
        onCheckChange={handleCheckChange}
        // allowMultiple={true}
      />
    </Box>
  );
};

export default ArrAccordionWithCheckboxDemo;
